import React from 'react'

const Wifi = () => {
  return (
    <div className='bg-blue-950 min-h-screen'>
      <div>
      <h1 className='text-white font-serif font-bold text-center pt-5 capitalize xxs:text-3xl xs:text-5xl'>Rdx Portfolio</h1>
      <h1 className='text-red-500 pt-2 font-serif font-bold text-center capitalize xxs:text-3xl  xs:text-5xl'>OFFLINE !</h1>
    
     <div className='text-center  flex justify-center'> 
        <img className='bg-transparent  object-cover' src='./images/wifi2.webp'/>
    </div>
    <h1 className='text-white font-serif font-bold text-center  xs:text-2xl capitalize'>Oops <span className='text-red-600'>!</span> It seems you're offline <span className='text-red-600'>!</span> Please check your internet connection <span className='text-red-600'>?</span> </h1>

    </div>
    </div>
  )
}

export default Wifi
